import axios from 'axios';
import { useQuery, UseQueryOptions } from 'react-query';
import { handleAxiosResponse } from '../utils/handleAxiosResponse';
import { apiMaintenanceMode } from '../endpoints/endpoints';
import { queryKeys } from '../react-query/queryKeys';
import { MaintenanceModeModel } from '../utils/interface';

interface MaintenanceModeCrudMethods<T1> {
  get: () => Promise<T1>;
}

export const MaintenanceModeHttpService: MaintenanceModeCrudMethods<MaintenanceModeModel> = {
  get: async (): Promise<MaintenanceModeModel> => {
    const response = await axios({
      url: `${apiMaintenanceMode}`,
      method: 'GET'
    });

    return handleAxiosResponse(response);
  }
};

export const useCheckMaintenanceMode = (options: Omit<UseQueryOptions<MaintenanceModeModel>, 'queryKey' | 'queryFn'> = {}) => {
  return useQuery<MaintenanceModeModel>([queryKeys.maintenanceModeCheck], () => MaintenanceModeHttpService.get(), {
    ...options
  });
};
